// Centralized role definitions for the front-end.
// Single source of truth — add a new role here ONCE and every gate/route updates with it.

// Every role that can access the POS portal (cashier, technician, manager, owner, corporate admin).
export const POS_ROLES = [
  'admin',
  'super_admin',
  'client_owner',
  'client_staff',
  'manager',
  'technician',
  'staff',
];

// Roles that should land on the Admin Portal after login (or be allowed full admin-tier API access).
export const ADMIN_TIER_ROLES = ['super_admin', 'admin', 'client_owner'];

export function isPosUser(role) {
  return POS_ROLES.includes(role);
}

export function isAdminTier(role) {
  return ADMIN_TIER_ROLES.includes(role);
}
